import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import {
  debounce,
  getDayjsObject,
  getOptionsFromRefList,
  getRefListNameByID,
  isNonEmptyVariable,
  hasCheckSecurity,
} from "@/util/common_function";
import { MODULES_LIST } from "@/util/common_variable";
import { Form, TimePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";

const Supervisor = ({
  data,
  updateForm = null,
  parentFieldEnable,
  fromkey = "",
}) => {
  const { userDetail } = useSelector((s) => s?.userDetail);
  const { bookingsFieldsEnabled } = useSelector((state) => state?.bookings);
  const [form] = Form.useForm();
  const [supervisorData, setSupervisorData] = useState(null);

  const status = Form.useWatch(
    isNonEmptyVariable(fromkey)
      ? [fromkey, 0, "supervisorStatus"]
      : "supervisorStatus",
    form,
  );

  useEffect(() => {
    console.log("🚀 ~ Supervisor ~ data:", data);
    if (isNonEmptyVariable(data)) {
      setSupervisorData({
        ...data,
        supervisorStaff: isNonEmptyVariable(data?.supervisorStaffId)
          ? getRefListNameByID("", data?.supervisorStaffId, true, true)
          : "",
        supervisorDateTime: getDayjsObject(
          data?.supervisorDate,
          data?.supervisorTime,
        ),
      });
    }
  }, [data]);

  useEffect(() => {
    if (isNonEmptyVariable(supervisorData)) {
      if (isNonEmptyVariable(fromkey)) {
        form.setFieldsValue({
          [fromkey]: [supervisorData],
        });
      } else {
        form.setFieldsValue(supervisorData);
      }
    }
  }, [supervisorData]);

  const changeStatus = (e) => {
    if (!isNonEmptyVariable(e)) return;
    form.setFieldValue(
      isNonEmptyVariable(fromkey)
        ? [fromkey, 0, "supervisorDateTime"]
        : "supervisorDateTime",
      dayjs(),
    );
    form.setFieldValue(
      isNonEmptyVariable(fromkey)
        ? [fromkey, 0, "supervisorStaffId"]
        : "supervisorStaffId",
      userDetail?.staffId,
    );
    form.setFieldValue(
      isNonEmptyVariable(fromkey)
        ? [fromkey, 0, "supervisorRejectReason"]
        : "supervisorRejectReason",
      "",
    );
  };

  const dataModify = debounce(async () => {
    const formValues = await form.validateFields();
    let values = formValues;
    if (isNonEmptyVariable(fromkey)) {
      values = formValues?.[fromkey]?.[0];
    }

    const _supervisorDateTime = values?.supervisorDateTime
      ? dayjs(values?.supervisorDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    const data = {
      ...values,
      supervisorDate: _supervisorDateTime?.split(" ")?.[0],
      supervisorTime: _supervisorDateTime?.split(" ")?.[1],
    };

    delete data?.supervisorDateTime;

    updateForm(data);
  }, 800);

   const hasAdminPermission = hasCheckSecurity(
    Security_Types.functionality,
    "Arbitrary",
    LABELS_CAPITAL.ADD,
    "Sup-View",
  );
  // const options = getOptionsFromRefList("JailIncidentsStatusAdministrator");
  // useEffect(() => {
  //   if (!hasAdminPermission) {

  //     const pendingOption = options?.find(
  //       (opt) => opt.label === "Pending"
  //     );

  //     if (pendingOption) {

  //       const fieldPath = isNonEmptyVariable(fromkey)
  //         ? [fromkey, 0, "supervisorStatus"]
  //         : "supervisorStatus";

  //       form.setFieldValue(fieldPath, pendingOption.value);
  //     }
  //   }
  // }, [hasAdminPermission]);

  const allOptions = getOptionsFromRefList("JailIncidentsStatusAdministrator");

  const filteredOptions = !hasAdminPermission
    ? allOptions?.filter(
        (opt) => opt.label?.trim().toLowerCase() === "pending"
      )
    : allOptions;

  return (
    <>
      <StyledSectionHeading marginBottom="15px">
        <span>Supervisor</span>
      </StyledSectionHeading>
      <Form
        form={form}
        onFieldsChange={() => {
          if (isNonEmptyVariable(updateForm)) dataModify();
        }}
      >
        <StyledGridRow gutter={[16]}>
          <StyledGridCol lg={12}>
            <FormItem
              label="Supervisor Name"
              name={
                isNonEmptyVariable(fromkey)
                  ? [fromkey, 0, "supervisorStaffId"]
                  : "supervisorStaffId"
              }
            >
              <Select
                id="supervisorStaffId"
                options={getOptionsFromRefList("", true, false, true)}
                placeholder="Select Supervisor"
                disabled={!bookingsFieldsEnabled || !parentFieldEnable }
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem
              label="Status"
              name={
                isNonEmptyVariable(fromkey)
                  ? [fromkey, 0, "supervisorStatus"]
                  : "supervisorStatus"
              }
            >
              <Select
                id="supervisorStatus"
                options={filteredOptions}
                placeholder="Select Status"
                disabled={!bookingsFieldsEnabled || !parentFieldEnable }
                onChange={changeStatus}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem
              label="Date & Time"
              name={
                isNonEmptyVariable(fromkey)
                  ? [fromkey, 0, "supervisorDateTime"]
                  : "supervisorDateTime"
              }
            >
              <CommonDatePicker
                id="reportingDateTime"
                format="MM/DD/YYYY HH:mm"
                disabled={!bookingsFieldsEnabled || !parentFieldEnable }
              />
            </FormItem>
          </StyledGridCol>
          {status === "Rejected" && (
            <StyledGridCol xs={24} lg={24}>
              <FormItem
                label="Reject Reason"
                name={
                  isNonEmptyVariable(fromkey)
                    ? [fromkey, 0, "supervisorRejectReason"]
                    : "supervisorRejectReason"
                }
              >
                <TextField
                  inputType="textarea"
                  rows="2"
                  disabled={!bookingsFieldsEnabled || !parentFieldEnable}
                />
              </FormItem>
            </StyledGridCol>
          )}
        </StyledGridRow>
      </Form>
    </>
  );
};

export default Supervisor;
